/**
 * convert the segment names used in the data source
 * to the display names that will be rendered
 */
const SEGMENTS_MAPPING = {
  // siding segments
  eaves: 'Level Frieze Boards',
  inside_corners: 'Inside Corners',
  level_bases: 'Level Starters',
  opening_bottoms: 'Opening Sills',
  opening_sides: 'Opening Sides',
  opening_tops: 'Opening Tops',
  outside_corners: 'Outside Corners',
  perimeter: 'Vertical Trims',
  rakes: 'Sloped Frieze Boards',
  shutter: 'Shutters',
  sloped_bases: 'Sloped Trims',
  vents: 'Vents',
  // roof segments
  eave: 'Eaves',
  flashing: 'Flashings',
  hip: 'Hips',
  rake: 'Rakes',
  ridge: 'Ridges',
  step_flashing: 'Step Flashings',
  valley: 'Valleys',
};

const SEGMENTS = {
  siding: 'Siding Segments',
  brick: 'Brick Segments',
  concrete: 'Concrete Segments',
  roof: 'Roof Segments',
  stucco: 'Stucco Segments',
  stone: 'Stone Segments',
  wrap: 'Wrap Segments',
};

const MEASUREMENTS_HIDDEN_IF_SAVED_MODEL = [SEGMENTS.siding, SEGMENTS.roof];

const MEASUREMENTS = {
  surfaceAreas: 'Surface Areas',
  openings: 'Openings',
};

const UNITS = {
  feet: {
    abbreviation: ' ft',
    symbol: "'",
  },
  inches: {
    abbreviation: ' in',
    symbol: '"',
  },
};

const HORIZONTAL_SIDING = 'Horizontal Siding Faces';
const VERTICAL_SIDING = 'Vertical Siding Faces';
const SHINGLED_SIDING = 'Shingled Siding Faces';
const OTHER_SIDING = 'Other Siding Faces';
const STUCCO = 'Stucco Faces';
const STONE = 'Stone Faces';
const BRICK = 'Brick Faces';

const MAIN_MATERIALS = {
  601: HORIZONTAL_SIDING,
  602: VERTICAL_SIDING,
  603: SHINGLED_SIDING,
  604: OTHER_SIDING,
  209: STUCCO,
  202: STONE,
  200: BRICK,
};

export default {
  HORIZONTAL_SIDING,
  VERTICAL_SIDING,
  SHINGLED_SIDING,
  OTHER_SIDING,
  STUCCO,
  STONE,
  BRICK,
  MAIN_MATERIALS,
  MEASUREMENTS,
  MEASUREMENTS_HIDDEN_IF_SAVED_MODEL,
  SEGMENTS,
  SEGMENTS_MAPPING,
  UNITS,
};
